import React from 'react';
import { Alert } from '@digitools/honest-react';
/**
 * Shared presenter for the two document-upload error alerts:
 *  - `error-alert`: validation failures (bad type/size/name, or a server-side rejection).
 *  - `api-error-alert`: upload/submit request failures, with a contact-us link.
 *
 * Kept in sync across RTW, CLI, and View Status so all three render identically.
 */
const UploadErrorAlerts = ({ errorMessage, apiFailureMessage, languageFile, }) => {
    const contactUsLink = (<a href='/customer/home/contacts' target='_blank' rel='noopener noreferrer' aria-label={languageFile.contactUsNewTab}>
      {languageFile.contactUs}
    </a>);
    return (<>
      {errorMessage && (<Alert type={'error'} data-testid={'error-alert'}>
          <div>
            {errorMessage}
            {errorMessage === languageFile.uploadFileCorrupted && <>{contactUsLink}.</>}
          </div>
        </Alert>)}
      {apiFailureMessage && (<Alert type={'error'} data-testid={'api-error-alert'}>
          {languageFile.apiFailureMessage}
          {contactUsLink}.
        </Alert>)}
    </>);
};
export default UploadErrorAlerts;
